import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import { IoClose } from 'react-icons/io5';

import aboutSection1Bg from '../../assests/aboutsection1bg.png';
import homeicon from '../../assests/karaicon.svg';
import aboutSection2Image from '../../assests/aboutsection2rightimage.png';
import aboutSmallImage from '../../assests/aboutsection2leftimage.png';
import Footer from '../Footer'

const About = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isConceptOpen, setIsConceptOpen] = useState(false);

  const toggleConceptMenu = () => {
    setIsConceptOpen(!isConceptOpen);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Handle scroll behavior
  useEffect(() => {
    const controlNavbar = () => {
      const currentScrollY = window.scrollY;
      const section1Height = window.innerHeight; // Section 1 is 100vh
      const scrollDifference = currentScrollY - lastScrollY;

      // Check if scrolled past Section 1
      if (currentScrollY > section1Height) {
        setIsScrolled(true);

        // Only hide/show navbar when past Section 1
        if (scrollDifference < -5) {
          // Scrolling up (threshold -5px to avoid jitter)
          setShowNavbar(true);
        } else if (scrollDifference > 5) {
          // Scrolling down (threshold 5px to avoid jitter)
          setShowNavbar(false);
        }
      } else {
        // In Section 1 - always show navbar
        setIsScrolled(false);
        setShowNavbar(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', controlNavbar);

    return () => {
      window.removeEventListener('scroll', controlNavbar);
    };
  }, [lastScrollY]);

  return (
    <>
      {/* Navbar - Outside sections for fixed positioning */}
      {/* <nav className={`about-navbar ${showNavbar ? 'navbar-visible' : 'navbar-hidden'} ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="about-navbar-logo">
          <Link to="/">
            <img src={homeicon} alt="Kara Logo" className="about-logo-icon" />
          </Link>
        </div>
        <div className="about-navbar-menu" onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className="about-hamburger-icon">
            <circle cx="24.5" cy="24.5" r="24" fill="black" stroke="#9A9A9A"/>
            <rect x="13" y="16" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="23" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="30" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
          </svg>
        </div>
      </nav> */}

      {/* Navigation Menu Overlay */}
      {/* {isMenuOpen && (
        <div className="about-nav-overlay">
          <div className="about-nav-close" onClick={toggleMenu}>
            <IoClose className="about-close-icon" />
          </div>
          <nav className="about-navigation">
            <ul className="about-nav-list">
              <li className="active"><Link to="/about" onClick={toggleMenu}>About US</Link></li>
              <li><Link to="/process" onClick={toggleMenu}>Our Process</Link></li>
              <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li><Link to="/collections" onClick={toggleMenu}>Collections & Products</Link></li>
              <li><Link to="/sustainability" onClick={toggleMenu}>Sustainability & Ethical Sourcing</Link></li>
              <li><Link to="/private-client" onClick={toggleMenu}>Private Client Services</Link></li>
              <li><Link to="/hospitality" onClick={toggleMenu}>Hospitality & Commercial Solutions</Link></li>
              <li><Link to="/journal" onClick={toggleMenu}>Journal / Blog</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      )} */}

      {/* Navbar - Always Visible */}
      <nav className={`our-process-navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="our-process-navbar-logo">
          <Link to="/">
            <img src={homeicon} alt="Kara Logo" className="our-process-logo-icon" />
          </Link>
        </div>
        <div className="our-process-navbar-menu" onClick={toggleMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className="our-process-hamburger-icon">
            <circle cx="24.5" cy="24.5" r="24" fill="black" stroke="#9A9A9A"/>
            <rect x="13" y="16" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="23" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
            <rect x="13" y="30" width="24" height="3" rx="1.5" fill="#9A9A9A"/>
          </svg>
        </div>
      </nav>

      {/* Navigation Menu Overlay */}
      {isMenuOpen && (
        <div className="our-process-nav-overlay">
          <div className="our-process-nav-close" onClick={toggleMenu}>
            <IoClose className="our-process-close-icon" />
          </div>
          <nav className="our-process-navigation">
            <ul className="our-process-nav-list">
              <li className="active"><Link to="/about" onClick={toggleMenu}>About US</Link></li>
              <li><Link to="/process" onClick={toggleMenu}>Our Process</Link></li>
              <li><Link to="/services" onClick={toggleMenu}>Services</Link></li>
              <li><Link to="/collections" onClick={toggleMenu}>Collections & Products</Link></li>
              <li><Link to="/sustainability" onClick={toggleMenu}>Sustainability & Ethical Sourcing</Link></li>
              <li><Link to="/private-client" onClick={toggleMenu}>Private Client Services</Link></li>
              {/* <li className="nav-item-with-submenu">
                <span className="nav-concept-trigger" onClick={toggleConceptMenu}>
                  Concept <span className="dropdown-arrow">▼</span>
                </span>
                {isConceptOpen && (
                  <ul className="concept-submenu">
                    <li><Link to="/concept-1" onClick={toggleMenu}>Concept-1</Link></li>
                    <li><Link to="/concept-2" onClick={toggleMenu}>Concept-2</Link></li>
                  </ul>
                )}
              </li> */}
              <li><Link to="/concept" onClick={toggleMenu}>concept</Link></li>
              <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
            </ul>
          </nav>
        </div>
      )}

      {/* SECTION 1: About Section */}
      <section className="about-section-1">
        {/* Background Image */}
        <div className="about-section-1-background">
          <img src={aboutSection1Bg} alt="About Background" className="about-section-1-bg-image" />
        </div>

        {/* Overlay */}
        <div className="about-section-1-overlay"></div>

        {/* Bottom Content */}
        <div className="about-section-1-content">
          <p className="about-section-1-label">About US</p>
          <h1 className="about-section-1-title">
            Design That Does More Than<br />Just Look Beautiful
          </h1>
          <p className="about-section-1-description">
            At Kara, we don't just create products—we craft purposeful design solutions. 
            Rooted in intention, built on innovation, and elevated by craftsmanship, our work 
            is about solving interior challenges with one-of-one pieces that inspire, endure, and evolve.
          </p>
        </div>
      </section>

      {/* SECTION 2: Luxury Content Section */}
      <section className="about-section-2">
        <div className="about-section-2-container">
          {/* Left Content Div */}
          <div className="about-section-2-content">
            <h2 className="about-section-2-title">
              Luxury That <br />Respects the Past,<br />Shapes the Future.
            </h2>
            <p className="about-section-2-description margin">
              Kãra («кт) stems from the Sanskrit root Kriya, meaning to do, to act, to perform. 
              It reflects our belief that design must go beyond form—it must perform a function, 
              solve a problem, and carry meaning. 
            </p>
             <p className="about-section-2-description">
               An offshoot of Crea—our architecture and 
              interior design wing—Kara was born to explore product design with the same soul, 
              but through a different lens.
            </p>
            <div className="about-section-2-small-images">
              <img src={aboutSmallImage} alt="Design Detail" className="about-small-image" />
            </div>
          </div>

          {/* Right Image Div */}
          <div className="about-section-2-image-wrapper">
            <img src={aboutSection2Image} alt="Luxury Design" className="about-section-2-main-image" />
          </div>
        </div>
      </section>

      {/* SECTION 3: Handmade Section */}
        <section className="about-section-3">
        {/* Background Image - Bottom Left */}
        <div className="about-section-3-bg-overlay">
            <img 
            src={require('../../assests/aboutsection3bgimage.png')} 
            alt="Background Overlay" 
            className="about-section-3-bg-image" 
            />
        </div>

        <div className="about-section-3-container">
            {/* Heading */}
            <h2 className="about-section-3-heading">
            Handmade for the Few,<br />Designed to Last Forever.
            </h2>

            {/* Content Row */}
            <div className="about-section-3-content-row">
            {/* Top Text */}
            <div className="about-section-3-text-top">
                <p className="about-section-3-text">
                <span className="text-bold">Bespoke artisan collaborations</span>{' '}
                <span className="text-medium">with global and indigenous craftsmen.</span>
                </p>
            </div>

            {/* Center Image */}
            <div className="about-section-3-image-wrapper">
                <img 
                src={require('../../assests/aboutsection3image.png')} 
                alt="Artisan Craft" 
                className="about-section-3-main-image" 
                />
            </div>

            {/* Bottom Text */}
            <div className="about-section-3-text-bottom">
                <p className="about-section-3-text">
                <span className="text-bold">Material innovation –</span>{' '}
                <span className="text-medium">heritage materials blended with futuristic design</span>
                </p>
            </div>
            </div>
        </div>
        </section>
      
      {/* SECTION 4: Our Values */}
        <section className="about-section-4">
        <div className="about-section-4-container">
            {/* Heading */}
            <h2 className="about-section-4-heading">Our Values</h2>

            {/* Description */}
            <p className="about-section-4-description">
            Kara is a design studio driven by innovation, sustainability, and storytelling—crafting 
            custom furniture and objects that solve real problems and elevate human experience.
            </p>

            {/* Cards Container */}
            <div className="about-section-4-cards">
            {/* Card 1 */}
            <div className="about-section-4-card">
                <h3 className="about-section-4-card-heading">Traceable Transparency</h3>
                <p className="about-section-4-card-text">
                Full material provenance, blockchain verification.
                </p>
            </div>

            {/* Card 2 */}
            <div className="about-section-4-card">
                <h3 className="about-section-4-card-heading">Limited Luxury</h3>
                <p className="about-section-4-card-text">
                Only a few pieces per year, ensuring exclusivity.
                </p>
            </div>

            {/* Card 3 */}
            <div className="about-section-4-card">
                <h3 className="about-section-4-card-heading">Eco-Conscious Excellence</h3>
                <p className="about-section-4-card-text">
                Beyond sustainability—carbon-negative commitment.
                </p>
            </div>
            </div>
        </div>
        </section>

      {/* SECTION 5: Let's Co-Create Something */}
        <section className='about-section-5'> 
        <h1 className='about-section-5-heading-text'>Let’s Craft Something with Meaning</h1>
        <p className='about-section-5-para-text'>If you’re looking for a design partner to create something bespoke, sustainable, and solution-driven—we’re ready when you are.</p>
        <Link to="/contact">
            <button className='our-process-section-2-contact-button'>Meet Our Artisans</button>
        </Link>
        </section>

        <Footer/>

    </>
  );
};

export default About;